'use client'
import { useTranslation } from '../../hooks/useTranslation'

export default function GetInTouch() {
  const { t } = useTranslation();
  return (
    <div>
      <footer className="bg-[var(--background)] text-white py-8 sm:py-10 md:py-12">
        <div className="mx-auto px-4 sm:px-6 md:px-8 lg:mx-[40px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {/* Blue Road Lux Cars */}
            <div className="sm:col-span-2 lg:col-span-1">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.title')}</h3>
              <p className="text-[#969696] text-sm sm:text-base leading-relaxed">
                {t('footer.desc')}
              </p>
            </div>

            {/* Office Hours */}
            <div>
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.hour.title')}</h3>
              <div className="text-[#969696] text-sm space-y-1">
                <p>{t('footer.hour.time')}</p>
              </div>
            </div>

            {/* Connect With Us */}
            <div>
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.connect.title')}</h3>
              <div className="text-[#969696] text-sm space-y-2">
                <p className="break-words">{t('footer.connect.phone')}: +974507946317</p>
                <p className="break-words">{t('footer.connect.email')}: info@blueroadluxurycarrental.com</p>
                <p className="break-words">{t('footer.connect.address')}</p>
              </div>
            </div>

            {/* Location */}
            <div className="sm:col-span-2 lg:col-span-1">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.location')}</h3>
              <div className="bg-gray-700 rounded-lg h-28 sm:h-32 flex items-center justify-center">
                <span className="text-[#969696] font-semibold text-sm sm:text-base">MAP</span>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="border-t border-[#969696] mt-6 sm:mt-8 pt-4 sm:pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
            <p className="text-white text-xs sm:text-sm text-center sm:text-left">
              Copyright © 2025 - Blue Road Luxury Car Rental. All Rights Reserved.
            </p>
            <p className="text-white text-xs sm:text-sm text-center sm:text-right">
              Designed by codsynapse.com
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}